import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { signup, acceptInvite } from '../api';
import { setActiveOrg } from '../org';
import AuthLayout, { Field, Alert, inputClass, labelClass, primaryBtnClass } from '../components/AuthLayout';
import PasswordInput from '../components/PasswordInput';

function Signup() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const inviteToken = params.get('invite');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await signup(email, name, password);
      const { access_token, admin_email, admin_name, is_admin } = res.data;
      localStorage.setItem('admin_token', access_token);
      localStorage.setItem('admin_email', admin_email);
      localStorage.setItem('admin_name', admin_name);
      localStorage.setItem('admin_is_admin', is_admin ? 'true' : 'false');

      if (inviteToken) {
        try {
          const acc = await acceptInvite(inviteToken);
          if (acc.data?.org_id) { setActiveOrg(acc.data.org_id); navigate('/dashboard', { replace: true }); return; }
        } catch { /* fall through */ }
      }
      // No org required — land on the org hub to create or find one.
      navigate('/organizations', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Sign up failed');
    } finally { setLoading(false); }
  };

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Get started with LatentStack"
      footer={<>Already have an account? <Link to="/login" className="font-medium text-orange hover:underline">Sign in</Link></>}
    >
      <form onSubmit={handleSubmit}>
        <Alert>{error}</Alert>
        <Field label="Name">
          <input type="text" value={name} onChange={(e) => setName(e.target.value)}
            className={inputClass} placeholder="Your name" autoComplete="name" required />
        </Field>
        <Field label="Email">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            className={inputClass} placeholder="you@company.com" autoComplete="email" required />
        </Field>
        <div className="mb-5">
          <label className={labelClass}>Password</label>
          <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="At least 8 characters" autoComplete="new-password" />
        </div>
        <button type="submit" disabled={loading} className={primaryBtnClass}>
          {loading ? 'Creating account…' : 'Create account'}
        </button>
      </form>
    </AuthLayout>
  );
}

export default Signup;
